import React from "react";
import OdxIcon from "./Odx-Icon";
import {Link} from "react-router-dom";
import {cleansePageName, simplifyForHtmlId} from "../../Utils/transformer";
import {IModulePage} from "../../HubFramework/IHub";

interface OdxRailNavigationItemProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string
    isSelected?: boolean
    size: "sm" | "md" | "lg"
    title: string
    item: IModulePage
}

const OdxRailNavigationItem: React.FC<OdxRailNavigationItemProps> = ({
                                                                         title,
                                                                         item,
                                                                         className,
                                                                         size,
                                                                         isSelected = false,
                                                                         ...rest
                                                                     }) => {
    const combinedClassName = [
        "odx-rail-navigation-item",
        isSelected ? "is-selected" : "",
        className || ""
    ].join(" ").trim();

    return (
        <Link to={cleansePageName(item.displayName)} key={item.displayName} className={combinedClassName}>
            <OdxIcon name={item.icon.name} size={size} iconSet={item.icon.iconSet}/>
            <span className="odx-rail-navigation-item__container" id={simplifyForHtmlId(item.displayName)}>
                {title}
            </span>
        </Link>
    )
}

export default OdxRailNavigationItem;